import { render } from "./FilterKabupatenGroupRole.vue?vue&type=template&id=718d709e"
import script from "./FilterKabupatenGroupRole.vue?vue&type=script&lang=js"
export * from "./FilterKabupatenGroupRole.vue?vue&type=script&lang=js"
script.render = render

export default script